import styled from 'styled-components';

import { Text } from 'features/common/components/Text';

export const Title = styled(Text)`
	font-size: 20px;
	align-self: start;
	margin-bottom: 25px;
`;
